'use es6';

import { BaseResponsiveEmptyContainerToolbar, buildActionsForEmptyColumn } from './BaseResponsiveEmptyContainerToolbar';

/**
 * @param {string} props.responsiveSize (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileEmptyContainerToolbarToMeasure = ({
  responsiveSize
}) => {
  // Note currently assuming buildActionsForEmptyColumn and buildActionsForEmptyRow always return
  // the same number of actions
  return /*#__PURE__*/_jsx(BaseResponsiveEmptyContainerToolbar, {
    actions: buildActionsForEmptyColumn(),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveMobileEmptyContainerToolbarToMeasure,
// These are logically the same toolbars, so just export an alias
MockResponsiveMobileEmptyContainerToolbarToMeasure as MockResponsiveDesktopEmptyContainerToolbarToMeasure };